/**
 * Created by yuanlei on 2020/8/5.
 */
// 自动按需引入 Vant 组件
import {
  Empty,
  Step, Steps,
  Image,
  Card,
  DatetimePicker,
  Picker,
  Col,
  Row,
  List,
  PullRefresh,
  Tabbar,
  TabbarItem,
  Button,
  Form,
  Cell,
  CellGroup,
  Field,
  Toast,
  Dialog,
  NavBar,
  Popup,
  Area,
  Uploader,
  Search,
  Tab,
  Tabs,
  Icon
} from 'vant'
// 注册组件集合
let vantUIs = [
  Empty,
  Step, Steps,
  Image,
  Card,
  DatetimePicker,
  Picker,
  Col, Row,
  List,
  PullRefresh,
  Tabbar,
  TabbarItem,
  Button,
  Form,
  Cell,
  CellGroup,
  Field,
  Toast,
  Dialog,
  NavBar,
  Popup,
  Area,
  Uploader,
  Search,
  Tab,
  Tabs,
  Icon
]
// 注册组件并暴露
export default {
  install (Vue) {
    vantUIs.forEach(vantUI => {
      Vue.component(vantUI.name,
        vantUI)
      // Vue.use(vantUI)    // 也可以使用 Vue.use()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/vant.js